"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _views = require("./../site-selector-components/views");

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

require("./lang");

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var SiteGroupItem = function SiteGroupItem(_ref) {
  var dataElementLocation = _ref.dataElementLocation,
      dataElementIdPrefix = _ref.dataElementIdPrefix,
      site = _ref.site,
      onItemClick = _ref.onItemClick,
      onMenuItemBtnClick = _ref.onMenuItemBtnClick;
  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  return /*#__PURE__*/_react["default"].createElement(_views.StyledMenuItem, (0, _extends2["default"])({
    onClick: function onClick() {
      onItemClick();
      onMenuItemBtnClick();
    }
  }, (0, _taggingHelper.getDataProperty)({
    dataElementLocation: dataElementLocation,
    dataElementLabel: dataElementIdPrefix,
    dataElementId: "".concat(dataElementIdPrefix, "-menu_item"),
    dataElementType: _taggingHelper.DataElementTypes.MENUITEM
  }), {
    dataElementLocation: dataElementLocation,
    dataElementLabel: dataElementIdPrefix,
    dataElementId: "".concat(dataElementIdPrefix, "-menu_item"),
    dataElementType: _taggingHelper.DataElementTypes.MENUITEM
  }), site && /*#__PURE__*/_react["default"].createElement(_views.GroupItemContainer, null, /*#__PURE__*/_react["default"].createElement(_views.SiteThumbnail, {
    screenshot: site.screenshot
  }), /*#__PURE__*/_react["default"].createElement(_views.DescriptionBox, {
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_views.SiteDetails, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h4"
  }, site.name), site.saved && /*#__PURE__*/_react["default"].createElement(_views.LastEditedText, {
    variant: "body2"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "modules.navigation.siteselector.groupitem.lastEdited"
  }), _moment["default"].utc(site.saved).local().fromNow())), /*#__PURE__*/_react["default"].createElement(_views.SiteStatusIndicatorContainer, {
    isMobile: isMobile
  }, site && (site.published ? /*#__PURE__*/_react["default"].createElement(_views.SiteStatusIndicator, {
    published: true,
    id: "".concat(dataElementIdPrefix, "-menu_item_chip-site_published"),
    label: /*#__PURE__*/_react["default"].createElement(_views.SiteStatusIndicatorText, {
      variant: "label"
    }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "modules.navigation.siteselector.groupitem.published"
    }))
  }) : /*#__PURE__*/_react["default"].createElement(_views.SiteStatusIndicator, {
    id: "".concat(dataElementIdPrefix, "-menu_item_chip-site_unpublished"),
    label: /*#__PURE__*/_react["default"].createElement(_views.SiteStatusIndicatorText, {
      variant: "label"
    }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "modules.navigation.siteselector.groupitem.unpublished"
    }))
  }))))));
};

SiteGroupItem.propTypes = {
  classes: _propTypes["default"].object,
  dataElementLocation: _propTypes["default"].string,
  dataElementIdPrefix: _propTypes["default"].string,
  site: _propTypes["default"].object,
  onItemClick: _propTypes["default"].func.isRequired,
  onMenuItemBtnClick: _propTypes["default"].func.isRequired
};
var _default = SiteGroupItem;
exports["default"] = _default;